export default {
  namespaced: true,
  totem_logs: {
    title: "totem logs",
    data: "data",
    host: "host",
    response: "response",
  },
};
